<nav class="navbar navbarcustom">
  <div class="container-fluid">
    @if (!isMobileSearch) {
      <a
        class="navbar-brand d-flex align-items-center"
        [routerLink]="['/callcenter/pipeline/A0']"
        >
        <span class="custom-logo">
          <img
            src="/assets/images/TMCV-New-Logo.png"
            alt="Tata Motors Commercial Vehicles"
            height="42"
            class="d-inline-block"
            />
          &nbsp;
        </span>
        &nbsp;
        <span class="navbar-text ms-2">FleetCare</span>
        <!-- <span>
        <button  (click)="detectMobileView(true)"class="navbar-toggler d-block d-md-none" type="button" >
          <span class="navbar-toggler-icon"></span>
        </button>
      </span> -->
    </a>
    <i
      class="ti ti-menu-2 ti-md t-menu d-block d-md-none"
      (click)="detectMobileView(true)"
    ></i>
    <!-- <a class="navbar-brand">
    <span class="logo">
      <img src="/assets/images/TMCV-New-Logo.png" height="42" />
    </span>
  </a> -->
  <div
    class="text-center d-none d-md-block flex-grow-1-se search-container position-relative"
    >
    <!-- <i class="ti ti-search ti-md t-menu search-icon position-absolute"></i>
    <input
      class="form-control me-2 d-none d-md-block search-input"
      type="search"
      placeholder="Search"
      aria-label="Search" maxlength="20"
      /> -->
    </div>
    <form class="d-flex">
      <ul class="navbar-nav flex-row align-items-center ms-auto">
        <li>
          @if (!shouldHideButton()) {
            <button class="btn btn-tata-motors btn-lg" (click)="createVasorder(true)">
              Book VAS
            </button>
            }&nbsp;&nbsp;
          </li>
          <li class="d-block d-md-none">
            <i class="ti ti-search ti-md t-menu" (click)="SerachMbInfo()"></i>
          </li>
          <li
            class="after-link left-bell-mb-icon nav-item dropdown-notifications navbar-dropdown dropdown me-3 me-xl-2"
            >
          <a
            class="nav-link btn btn-text-secondary btn-icon rounded-pill"
            href="javascript:void(0);"
            data-bs-auto-close="outside"
            aria-expanded="false"
            href="/callcenter/pipeline/A0"
            >
            <span class="position-relative">
              <!-- bx bx-search bx-md -->
              <i class="ti ti-home ti-md t-menu"></i>
            </span>
          </a>
          <!-- <a
          class="nav-link btn btn-text-secondary btn-icon rounded-pill dropdown-toggle hide-arrow"
          href="javascript:void(0);"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
          aria-expanded="false"
          [routerLink]="['/callcenter/dashboard']"
          >
          <span class="position-relative">
            <i class="ti ti-bell ti-md t-menu"></i>
            <span
              class="badge rounded-pill bg-danger badge-dot badge-notifications border"
            ></span>
          </span>
        </a> -->
        <ul
          class="dropdown-menu dropdown-menu-notification dropdown-menu-end p-0"
          >
          <li class="dropdown-menu-header border-bottom">
            <div class="dropdown-header d-flex align-items-center py-3">
              <h6 class="mb-0 me-auto">Notification</h6>
              <div class="d-flex align-items-center h6 mb-0">
                <span class="badge bg-label-primary me-2">8 New</span>
                <a
                  href="javascript:void(0)"
                  class="btn btn-text-secondary rounded-pill btn-icon dropdown-notifications-all"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Mark all as read"
                  ><i class="ti ti-mail-opened text-heading"></i
                ></a>
              </div>
            </div>
          </li>
          <li class="dropdown-notifications-list scrollable-container">
            <ul class="list-group list-group-flush">
              <li
                class="list-group-item list-group-item-action dropdown-notifications-item"
                >
                <div class="d-flex">
                  <div class="flex-shrink-0 me-3">
                    <div class="avatar">
                      <img
                        src="/assets/img/avatars/1.png"
                        alt
                        class="rounded-circle"
                        />
                    </div>
                  </div>
                  <div class="flex-grow-1">
                    <h6 class="small mb-1">Congratulation Lettie 🎉</h6>
                    <small class="mb-1 d-block text-body"
                      >Won the monthly best seller gold badge</small
                      >
                      <small class="text-muted">1h ago</small>
                    </div>
                    <div class="flex-shrink-0 dropdown-notifications-actions">
                      <a
                        href="javascript:void(0)"
                        class="dropdown-notifications-read"
                        ><span class="badge badge-dot"></span
                      ></a>
                      <a
                        href="javascript:void(0)"
                        class="dropdown-notifications-archive"
                        ><span class="ti ti-x"></span
                      ></a>
                    </div>
                  </div>
                </li>
                <li
                  class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read"
                  >
                  <div class="d-flex">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar">
                        <img
                          src="/assets/img/avatars/1.png"
                          alt
                          class="rounded-circle"
                          />
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="mb-1 small">New Message ✉️</h6>
                      <small class="mb-1 d-block text-body"
                        >You have new message from Natalie</small
                        >
                        <small class="text-muted">1h ago</small>
                      </div>
                      <div class="flex-shrink-0 dropdown-notifications-actions">
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-read"
                          ><span class="badge badge-dot"></span
                        ></a>
                        <a
                          href="javascript:void(0)"
                          class="dropdown-notifications-archive"
                          ><span class="ti ti-x"></span
                        ></a>
                      </div>
                    </div>
                  </li>
                  <li
                    class="list-group-item list-group-item-action dropdown-notifications-item"
                    >
                    <div class="d-flex">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                          <span
                            class="avatar-initial rounded-circle bg-label-success"
                            ><i class="ti ti-shopping-cart"></i
                          ></span>
                        </div>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="mb-1 small">Whoo! You have new order 🛒</h6>
                        <small class="mb-1 d-block text-body"
                          >ACME Incl. made new order $1,154</small
                          >
                          <small class="text-muted">1 day ago</small>
                        </div>
                        <div class="flex-shrink-0 dropdown-notifications-actions">
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-read"
                            ><span class="badge badge-dot"></span
                          ></a>
                          <a
                            href="javascript:void(0)"
                            class="dropdown-notifications-archive"
                            ><span class="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                    <li
                      class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read"
                      >
                      <div class="d-flex">
                        <div class="flex-shrink-0 me-3">
                          <div class="avatar">
                            <!-- <img
                            src="/assets/img/avatars/9.png"
                            alt
                            class="rounded-circle"
                            /> -->
                          </div>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1 small">
                            Application has been approved 🚀
                          </h6>
                          <small class="mb-1 d-block text-body"
                            >Your ABC project application has been
                            approved.</small
                            >
                            <small class="text-muted">2 days ago</small>
                          </div>
                          <div class="flex-shrink-0 dropdown-notifications-actions">
                            <a
                              href="javascript:void(0)"
                              class="dropdown-notifications-read"
                              ><span class="badge badge-dot"></span
                            ></a>
                            <a
                              href="javascript:void(0)"
                              class="dropdown-notifications-archive"
                              ><span class="ti ti-x"></span
                            ></a>
                          </div>
                        </div>
                      </li>
                      <li
                        class="list-group-item list-group-item-action dropdown-notifications-item"
                        >
                        <div class="d-flex">
                          <div class="flex-shrink-0 me-3">
                            <div class="avatar">
                              <!-- <img
                              src="/assets/img/avatars/6.png"
                              alt
                              class="rounded-circle"
                              /> -->
                            </div>
                          </div>
                          <div class="flex-grow-1">
                            <h6 class="mb-1 small">New message from Jane</h6>
                            <small class="mb-1 d-block text-body"
                              >Your have new message from Jane</small
                              >
                              <small class="text-muted">5 days ago</small>
                            </div>
                            <div class="flex-shrink-0 dropdown-notifications-actions">
                              <a
                                href="javascript:void(0)"
                                class="dropdown-notifications-read"
                                ><span class="badge badge-dot"></span
                              ></a>
                              <a
                                href="javascript:void(0)"
                                class="dropdown-notifications-archive"
                                ><span class="ti ti-x"></span
                              ></a>
                            </div>
                          </div>
                        </li>
                        <li
                          class="list-group-item list-group-item-action dropdown-notifications-item marked-as-read"
                          >
                          <div class="d-flex">
                            <div class="flex-shrink-0 me-3">
                              <div class="avatar">
                                <span
                                  class="avatar-initial rounded-circle bg-label-warning"
                                  ><i class="ti ti-alert-triangle"></i
                                ></span>
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-1 small">CPU is running high</h6>
                              <small class="mb-1 d-block text-body"
                                >CPU Utilization Percent is currently at
                                88.63%,</small
                                >
                                <small class="text-muted">5 days ago</small>
                              </div>
                              <div class="flex-shrink-0 dropdown-notifications-actions">
                                <a
                                  href="javascript:void(0)"
                                  class="dropdown-notifications-read"
                                  ><span class="badge badge-dot"></span
                                ></a>
                                <a
                                  href="javascript:void(0)"
                                  class="dropdown-notifications-archive"
                                  ><span class="ti ti-x"></span
                                ></a>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li class="border-top">
                        <div class="d-grid p-4">
                          <a
                            class="btn btn-primary btn-sm d-flex"
                            href="javascript:void(0);"
                            >
                            <small class="align-middle">View all notifications</small>
                          </a>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li
                    class="nav-item navbar-dropdown dropdown-user dropdown setting-details"
                    >
                    <a
                      class="nav-link dropdown-toggle hide-arrow p-0"
                      href="javascript:void(0);"
                      data-bs-toggle="dropdown"
                      >
                      <div class="avatar avatar-online all-option">
                        <img
                          src="/assets/img/avatars/1.png"
                          alt
                          class="rounded-circle"
                          />
                      </div>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-alloption dropdown-menu-end">
                      <li>
                        <a
                          class="dropdown-item mt-0"
                          href="pages-account-settings-account.html"
                          >
                          <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 me-2">
                              <div class="avatar avatar-online">
                                <img
                                  src="/assets/img/avatars/1.png"
                                  alt
                                  class="rounded-circle"
                                  />
                              </div>
                            </div>
                            <div class="flex-grow-1">
                              <h6 class="mb-0">{{ username || "Guest" }}</h6>
                              <small class="text-muted">{{
                                userType || "User" | uppercase
                              }}</small>
                            </div>
                          </div>
                        </a>
                      </li>
                      <li>
                        <div class="dropdown-divider my-1 mx-n2"></div>
                      </li>
                      <!-- <li>
                      <a class="dropdown-item" href="#">
                        <i class="ti ti-user me-3 ti-md"></i
                          ><span class="align-middle">My Profile</span>
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          href="#"
                          >
                          <i class="ti ti-settings me-3 ti-md"></i
                            ><span class="align-middle">Settings</span>
                          </a>
                        </li> -->
                        <!-- <li>
                        <a
                          class="dropdown-item"
                          href="pages-account-settings-billing.html"
                          >
                          <span class="d-flex align-items-center align-middle">
                            <i class="flex-shrink-0 ti ti-file-dollar me-3 ti-md"></i
                              ><span class="flex-grow-1 align-middle">Billing</span>
                              <span
                                class="flex-shrink-0 badge bg-danger d-flex align-items-center justify-content-center"
                                >4</span
                                >
                              </span>
                            </a>
                          </li>
                          <li>
                            <div class="dropdown-divider my-1 mx-n2"></div>
                          </li>
                          <li>
                            <a class="dropdown-item" href="pages-pricing.html">
                              <i class="ti ti-currency-dollar me-3 ti-md"></i
                                ><span class="align-middle">Pricing</span>
                              </a>
                            </li>
                            <li>
                              <a class="dropdown-item" href="pages-faq.html">
                                <i class="ti ti-question-mark me-3 ti-md"></i
                                  ><span class="align-middle">FAQ</span>
                                </a>
                              </li> -->
                              <li>
                                <div class="d-grid px-2 pt-2 pb-1">
                                  <a class="btn btn-sm btn-logout d-flex" (click)="logout()">
                                    <small class="align-middle">Logout</small>
                                    <i class="ti ti-logout ms-2 ti-14px"></i>
                                  </a>
                                </div>
                              </li>
                            </ul>
                          </li>
                          <!-- <li class="d-block d-md-none">
                          <i
                            class="ti ti-menu-2 ti-md t-menu"
                            (click)="detectMobileView(true)"
                          ></i>
                        </li> -->
                      </ul>
                    </form>
                  }
                  @if (isMobileSearch) {
                    <div
                      class="container-fluid d-flex justify-content-between align-items-center"
                      >
                      <input
                        class="form-control w-100 me-2 t-search-bg"
                        type="search"
                        placeholder="For eg: Dealer name, Dealer ID"
                        aria-label="Search"
                        />
                      <i
                        class="ti ti-x search-toggler cursor-pointer t-menu"
                        (click)="SerachMbInfo()"
                      ></i>
                    </div>
                    <!-- <div><input class="form-control me-2" type="search" placeholder="Search" aria-label="Search"></div>
                    <div>2</div> -->
                    <!-- <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
                    <i class="ti ti-x search-toggler cursor-pointer" (click)="SerachMbInfo()"></i> -->
                  }
                  <i
                    class="ti ti-menu-2 ti-md t-menu ipadview"
                    (click)="detectMobileView(true)"
                  ></i>
                </div>
              </nav>
